import React, { useState,useMemo, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {  useNavigate } from 'react-router-dom';
import {
  Table,
  Form,
  Button,
  InputGroup,
} from 'react-bootstrap';
import { link_tomi_to_channel, load_channel_tomis, remove_tomi_link } from '../../../../utils/crm_services';

function Admin_TOMis  ({ token, channel_id}) {
    // --- Estado de filtros/orden/columnas ---
    const navigate = useNavigate();   
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'channelName', dir: 'asc' });
  
    const [initialRows, setinitialRows] = useState([ ]);

    const [newSerial, setnewSerial] = useState('');

       useEffect(() => {
        fetchloadLinkedTOMis(channel_id);
        }, []); 

    // --- Filtrado + ordenamiento memoizados ---
    const rows = useMemo(() => {
      let result = initialRows;
  
      if (searchTerm) {
        const term = searchTerm.toLowerCase();
        result = result.filter((r) =>
          Object.values(r).some((v) => String(v).toLowerCase().includes(term))
        );
      }
  
      result = [...result].sort((a, b) => {
        const aVal = a[sortConfig.key];
        const bVal = b[sortConfig.key];
  
        if (aVal === bVal) return 0;
        const order = aVal > bVal ? 1 : -1;
        return sortConfig.dir === 'asc' ? order : -order;
      });
  
      return result;
    }, [searchTerm, sortConfig, initialRows]);
  
  
    async function add_tomi_serial() {
      const serialList = await link_tomi_to_channel(token,channel_id, newSerial);
      if (serialList==="INVALID"){
          navigate("/");
      }else{
        fetchloadLinkedTOMis(channel_id);
        setnewSerial('');
      }
    }

    async function remove_tomi_serial(link_serial_id) {
      const serialList = await remove_tomi_link(token, link_serial_id);
      if (serialList==="INVALID"){
          navigate("/");
      }else{
        fetchloadLinkedTOMis(channel_id);
      }
    }
  
     async function fetchloadLinkedTOMis(channel_id) {
                const serialList = await load_channel_tomis(token, channel_id);
                if (serialList==="INVALID"){
                    navigate("/");
                }else{
                 
                  const tempSerials = serialList.map((celement, index) => {
                    return {
                        id: celement.id,
                        tomi_serial: celement.tomi_serial,
                        index:index
                    };
                  });
               
                   setinitialRows( tempSerials);
                    
                }
                }
  
  
    // ---------- UI ----------
    return (
      <div className="container py-4">
  <div className="d-flex gap-2 mb-3 flex-wrap">
    <InputGroup className="flex-grow-1" style={{ maxWidth: 320 }}>
      <Form.Control
        placeholder="New serial"
        value={newSerial}
        onChange={(e) => setnewSerial(e.target.value)}
        className='toolbar-control'
      />
      <Button
        variant="primary"
        className="d-flex align-items-center toolbar-control"
        onClick={() => add_tomi_serial()}
      >
        {/* icono opcional si usas Bootstrap Icons */}
        {/* <i className="bi bi-plus-lg me-1" /> */}
        Add Serial
      </Button>
    </InputGroup>
  </div>
  {/* Barra de búsqueda + menús */}
  <div className="d-flex gap-2 mb-3 flex-wrap">
    <InputGroup className="flex-grow-1" style={{ maxWidth: 320 }}>
      <Form.Control
        placeholder="Search serial..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className='toolbar-control'
      />
    </InputGroup>
  </div>

  {/* Contenedor con alto máximo y scroll para la tabla */}
  <div style={{ maxHeight: '400px', overflowY: 'auto' }}> {/* Ajusta '400px' al alto deseado */}
    <Table hover responsive className="align-middle">
      <thead className="table-light" style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: 'white' }}> {/* Esto hace que el encabezado se mantenga visible al hacer scroll */}
        <tr>
          <th>
            TOMi Serial
          </th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id} >
            <td><a href={'/Units_status?serial=' + row.tomi_serial} target="_blank">{row.tomi_serial}</a></td>
            <td onClick={() => remove_tomi_serial(row.id)}>❌</td>
          </tr>

        ))}
        {rows.length === 0 && (
          <tr>
            <td colSpan="10" className="text-center py-4">
              No results
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  </div>
</div>
    );
};

export default Admin_TOMis;
